import * as React from "react";

export function Interruptor(props) {
  return (
    <svg
      width={92}
      height={92}
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_23_708)">
        <rect
          x={18.3076}
          y={16}
          width={54.7287}
          height={54.7287}
          rx={27.3644}
          fill="#FAFAFA"
        />
      </g>
      <path
        d="M53.988 51.678H37.361a8.263 8.263 0 01-8.314-8.314 8.263 8.263 0 018.314-8.314h16.627a8.263 8.263 0 018.314 8.314 8.263 8.263 0 01-8.314 8.314z"
        stroke="#081533"
        strokeWidth={1.35339}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.358 48.115a4.75 4.75 0 100-9.502 4.75 4.75 0 000 9.502z"
        stroke="#081533"
        strokeWidth={1.35339}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_23_708"
          x={0.283617}
          y={0.894866}
          width={90.7765}
          height={90.7765}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.91887} />
          <feGaussianBlur stdDeviation={9.012} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_23_708"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_23_708"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
